"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from "react";
import MarketplaceFoundationMintPreview from "./marketplace/MarketplaceFoundationMintPreview";
import MarketplaceGammaioPreview from "./marketplace/MarketplaceGammaioPreview";
import MarketplaceManifoldListingPreview from "./marketplace/MarketplaceManifoldListingPreview";
import MarketplaceOpenseaAssetPreview from "./marketplace/MarketplaceOpenseaAssetPreview";
import MarketplaceOpenseaItemPreview from "./marketplace/MarketplaceOpenseaItemPreview";
import MarketplaceSuperrareArtworkPreview from "./marketplace/MarketplaceSuperrareArtworkPreview";
import MarketplaceTransientMintPreview from "./marketplace/MarketplaceTransientMintPreview";
import MarketplaceTransientNftPreview from "./marketplace/MarketplaceTransientNftPreview";
import MarketplaceUnavailableCard from "./marketplace/MarketplaceUnavailableCard";
import { getMarketplaceUrlKind } from "./marketplace/urlKind";
interface MarketplacePreviewProps {
  readonly href: string;
  readonly compact?: boolean | undefined;
}
export default function MarketplacePreview(t0) {
  const $ = _c(29);
  const {
    href,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const kind = getMarketplaceUrlKind(href);
  let content;
  bb0: switch (kind) {
    case "manifold.listing":
      {
        let t2;
        if ($[0] !== compact || $[1] !== href) {
          t2 = <MarketplaceManifoldListingPreview href={href} compact={compact} />;
          $[0] = compact;
          $[1] = href;
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        content = t2;
        break bb0;
      }
    case "superrare.artwork":
      {
        let t2;
        if ($[3] !== compact || $[4] !== href) {
          t2 = <MarketplaceSuperrareArtworkPreview href={href} compact={compact} />;
          $[3] = compact;
          $[4] = href;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        content = t2;
        break bb0;
      }
    case "foundation.mint":
      {
        let t2;
        if ($[6] !== compact || $[7] !== href) {
          t2 = <MarketplaceFoundationMintPreview href={href} compact={compact} />;
          $[6] = compact;
          $[7] = href;
          $[8] = t2;
        } else {
          t2 = $[8];
        }
        content = t2;
        break bb0;
      }
    case "gammaio.collection":
    case "gammaio.collection-token":
    case "gammaio.inscription":
    case "gammaio.ordinal":
    case "gammaio.ordinal-inscription":
    case "gammaio.ordinal-collection-inscription":
    case "gammaio.ordinal-print-details":
    case "gammaio.stacks-nft":
      {
        let t2;
        if ($[9] !== compact || $[10] !== href) {
          t2 = <MarketplaceGammaioPreview href={href} compact={compact} />;
          $[9] = compact;
          $[10] = href;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        content = t2;
        break bb0;
      }
    case "opensea.item":
      {
        let t2;
        if ($[12] !== compact || $[13] !== href) {
          t2 = <MarketplaceOpenseaItemPreview href={href} compact={compact} />;
          $[12] = compact;
          $[13] = href;
          $[14] = t2;
        } else {
          t2 = $[14];
        }
        content = t2;
        break bb0;
      }
    case "opensea.asset":
      {
        let t2;
        if ($[15] !== compact || $[16] !== href) {
          t2 = <MarketplaceOpenseaAssetPreview href={href} compact={compact} />;
          $[15] = compact;
          $[16] = href;
          $[17] = t2;
        } else {
          t2 = $[17];
        }
        content = t2;
        break bb0;
      }
    case "transient.nft":
      {
        let t2;
        if ($[18] !== compact || $[19] !== href) {
          t2 = <MarketplaceTransientNftPreview href={href} compact={compact} />;
          $[18] = compact;
          $[19] = href;
          $[20] = t2;
        } else {
          t2 = $[20];
        }
        content = t2;
        break bb0;
      }
    case "transient.mint":
      {
        let t2;
        if ($[21] !== compact || $[22] !== href) {
          t2 = <MarketplaceTransientMintPreview href={href} compact={compact} />;
          $[21] = compact;
          $[22] = href;
          $[23] = t2;
        } else {
          t2 = $[23];
        }
        content = t2;
        break bb0;
      }
    case null:
      {
        let t2;
        if ($[24] !== compact || $[25] !== href) {
          t2 = <MarketplaceUnavailableCard href={href} compact={compact} />;
          $[24] = compact;
          $[25] = href;
          $[26] = t2;
        } else {
          t2 = $[26];
        }
        content = t2;
      }
  }
  let t2;
  if ($[27] !== content) {
    t2 = <div onClick={_temp}>{content}</div>;
    $[27] = content;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  return t2;
}
function _temp(event) {
  return event.stopPropagation();
}